import React, { useState } from 'react';
import { useQuery } from '@apollo/client';

import {
  filterStyles as styles,
  FilterTextInput,
  FilterSelect,
  FilterNativeSelect,
  FilterRange,
} from 'app/src/elements/Filter/inlineFilters';
import { SELLER_USER_SELECT_OPTIONS } from './queries';

// Shares the assignedTo filter with the seller user ids; Asset.filter_table
// reads the same sentinel.
export const UNASSIGNED = 'unassigned';

const TITLE_STATUS_OPTIONS =
  ['Received', 'Transferred', 'Release', 'Problem'].map(
    status => ({ value: status, label: status })
  );

const IndexFilters = ({ filters, setFilter, onClear }) => {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const { data } = useQuery(SELLER_USER_SELECT_OPTIONS);

  return (
    <div style={styles.container}>
      <div style={styles.grid}>
        <FilterTextInput
          label="Search"
          value={filters.search}
          onChange={value => setFilter('search', value)}
        />
        <FilterNativeSelect
          label="Assigned To"
          value={filters.assignedTo}
          onChange={value => setFilter('assignedTo', value)}
        >
          <option value="" />
          <option value={UNASSIGNED}>Unassigned</option>
          {(data?.sellerUsers || []).map(sellerUser => (
            <option key={sellerUser.id} value={sellerUser.id}>
              {sellerUser.fullName}
            </option>
          ))}
        </FilterNativeSelect>
        <FilterTextInput
          label="Make"
          value={filters.make}
          onChange={value => setFilter('make', value)}
        />
        <FilterTextInput
          label="Model"
          value={filters.model}
          onChange={value => setFilter('model', value)}
        />
      </div>

      {showAdvanced &&
        <div style={styles.advancedGrid}>
          <FilterTextInput
            label="Vin"
            value={filters.vin}
            onChange={value => setFilter('vin', value)}
          />
          <FilterTextInput
            label="Client #"
            value={filters.clientNumber}
            onChange={value => setFilter('clientNumber', value)}
          />
          <FilterSelect
            label="Title Status"
            options={TITLE_STATUS_OPTIONS}
            value={filters.cachedTitleStatus}
            onChange={value => setFilter('cachedTitleStatus', value)}
          />
          <FilterRange
            label="Year"
            minValue={filters.yearMin}
            maxValue={filters.yearMax}
            onChangeMin={value => setFilter('yearMin', value)}
            onChangeMax={value => setFilter('yearMax', value)}
          />
        </div>
      }

      <div style={styles.footer}>
        <button
          type="button"
          style={styles.linkButton}
          onClick={() => setShowAdvanced(!showAdvanced)}
        >
          {showAdvanced ? 'Fewer search options' : 'More search options'}
        </button>
        <button
          type="button"
          style={styles.linkButton}
          onClick={onClear}
        >
          Clear filters
        </button>
      </div>
    </div>
  );
};

export default IndexFilters;
